import request from '@/utils/request'

//字典项接口
// export function getCategory(data) {
//   // return get('/category', data)
//   return request({
//     url: '/category',
//     method: 'get',
//     params: data
//   })
// }


/*在线咨询-历史咨询列表*/
export function getHistoryCultList(parameter) {
  return request({
    url: '/consult',
    method: 'get',
    params: parameter
  })
}

/*律师服务查询列表*/
export function getLawyerServiceList(parameter) {
  return request({
    url: '/lawyerAppointment',
    method: 'get',
    params: parameter
  })
}
/*律师服务查询列表-详情*/
export function getAppointDetail(parameter) {
  return request({
    url: '/lawyerAppointment/'+parameter.id,
    method: 'get',
  })
}
/*律师服务-新增*/
export function getLawyerServiceAdd(parameter) {
  return request({
    url: '/lawyerAppointment',
    method: 'post',
    data: parameter
  })
}

/*律师可用时间查询*/
export function getLawyerAppointtime(parameter) {
  return request({
    url: '/lawyerAppointtime',
    method: 'get',
    params: parameter
  })
}

/*律师可用时间查询*/
export function getDept(parameter) {
  return request({
    url: '/dept/tree',
    method: 'get',
    params: parameter
  })
}

//上传文件接口
export function uploadannex(data) {
  // return post1('/annex/uploads', data)
  return request({
    url: '/annex/uploads',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data;charset=utf-8'
    },
    data: data
  })
}
